import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { AppAlertService } from './app-alert.service';
import { Router, NavigationStart } from '@angular/router';

@Injectable()
export class GeorefApiService {
	constructor(private _router: Router, private http: HttpClient, private _appAlertService: AppAlertService) {
		_router.events.forEach(event => {
			if (event instanceof NavigationStart) {
				this._appAlertService.reset();
			}
		});
	}

	private handleResponse(response, showErrorMessages = true) {
		if (!showErrorMessages) {
			return response;
		}

		switch (response['result']) {
			case 'error':
				// this._appAlertService.reset();
				if (response.validationErrors) {
					this._appAlertService.warning(response['userMessage']);
					const _validationErrors = [];
					let _messageValidationErrors = '<ul>';
					response.validationErrors.forEach(function(elementX) {
						_validationErrors[elementX.propertyPath] = _validationErrors[elementX.propertyPath]
							? `${_validationErrors[elementX.propertyPath]} ${elementX.message}`
							: elementX.message;
						_messageValidationErrors += `<li>${elementX.propertyPath}: ${
							_validationErrors[elementX.propertyPath]
						}</li>`;
					});
					response.validationErrors = _validationErrors;
				} else {
					if (response['userMessage'] === 'forbidden') {
						this._appAlertService.withoutPermits(
							'No tiene permisos para acceder a esta funcionalidad. Puede cambiar de usuario accediendo '
						);
					} else {
						this._appAlertService.error(response['userMessage']);
					}
				}
				return response;
			case 'info':
				// this._appAlertService.reset();
				this._appAlertService.info(response['userMessage']);
				return response;
			case 'ok':
				// this._appAlertService.reset();
				return response;
			default:
				// this._appAlertService.reset();
				return response;
		}
	}

	private handleError(error: HttpErrorResponse) {
		// his._appAlertService.reset();
		if (error.status === 401) {
			this._appAlertService.reset();
			switch (error.error.error) {
				case 'invalid_grant':
					this._appAlertService.reset();
					window.scrollTo(0, 0);
					this._appAlertService.login(
						'Debe iniciar Sesión. Puede hacerlo accediendo <a href="/login">aquí</a>'
					);
					break;
				case 'access_denied':
					this._appAlertService.reset();
					window.scrollTo(0, 0);
					this._appAlertService.withoutPermits(
						'No tiene permisos para realizar esta accion. Puede cambiar de usuario accediendo <a href="/login">aquí</a>'
					);
					break;
				default:
					this._appAlertService.warning('No esta autorizado');
					break;
			}
		} else if (error.status === 403) {
			this._appAlertService.reset();
			window.scrollTo(0, 0);
			this._appAlertService.withoutPermits(
				'No tiene permisos para acceder a esta funcionalidad. Puede cambiar de usuario accediendo <a href="/login">aquí</a>'
			);
		} else if (error.status === 400) {
			this._appAlertService.reset();
			if (error.error && error.error.userMessage) {
				this._appAlertService.warning(error.error.userMessage);
			} else {
				this._appAlertService.warning('Hubieron validaciones no superadas por los datos enviados ');
			}
			if (error.error.validationErrors) {
				const _validationErrors = [];
				error.error.validationErrors.forEach(function(elementX) {
					_validationErrors[elementX.propertyPath] = _validationErrors[elementX.propertyPath]
						? `${_validationErrors[elementX.propertyPath]} ${elementX.message}`
						: elementX.message;
				});
				return (error.error.validationErrors = _validationErrors);
			}
		} else {
			if (error.error instanceof ErrorEvent) {
				console.error(`Algo salio mal: "${error.error.message}"`);
				this._appAlertService.error(`Algo salio mal: "${error.error.message}"`);
			} else {
				console.error(
					`Algo salio mal: Backend returned status code "${error.status}", status: "${error.statusText}", message: "${error.message}"`
				);
				this._appAlertService.error(`Algo salio mal: "${error.error.userMessage}"`);
			}
		}
		return throwError('Algo salio mal; Por favor vuelva a intentar mas tarde.');
	}

	get(path: string, params: Object = {}, showErrorMessages = true, absolutePath = false): Observable<any> {
		let httpParams: HttpParams = new HttpParams();
		const route = absolutePath ? path : this.parsePath(path);

		if (params) {
			Object.keys(params).forEach(key => {
				httpParams = httpParams.append(key, params[key]);
			});
		}

		return this.http.get(route, { params: httpParams }).pipe(
			catchError((err, caught) => this.handleError(err)),
			map(response => this.handleResponse(response, showErrorMessages))
		);
	}

	parsePath(path: string): string {
		return `${environment.georef_api_url}${path}`;
	}
}
